module.exports = __webpack_public_path__ + "img/campus_Image_a.31518274.png";